/* eslint react/no-array-index-key: 1 */

import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import { createForm } from 'rc-form';
import { Grid, withStyles } from '@material-ui/core';

import TableFilterDate from './TableFilterDate';
import TableFilterDropDown from './TableFilterDropDown';
import TableFilterSearch from './TableFilterSearch';
import TableFiltersMultiSelect from './TableFiltersMultiSelect';

const styles = (theme) => ({
    filtersPaper: {
        padding: 30,
        width: 290,
    },
    filters: {
        marginBottom: 10,
    },
});

class TableFilters extends PureComponent {
    render() {
        const { classes, filters = [], intl, onChange, activeFilters } = this.props;

        return (
            <Grid className={classes.filtersPaper}>
                {filters.map((filter, index) => {
                    switch (filter.type.toLowerCase(filter)) {
                        case 'dropdown':
                            return (
                                <TableFilterDropDown
                                    onChange={onChange}
                                    key={`${filter.fieldName} ${index}`}
                                    filter={filter}
                                    activeFilters={activeFilters.dropdown}
                                    className={classes.filters}
                                />
                            );
                        case 'multiselect':
                            return (
                                <TableFiltersMultiSelect
                                    onChange={onChange}
                                    key={`${filter.fieldName} ${index}`}
                                    filter={filter}
                                    activeFilters={activeFilters.multiselect}
                                    className={classes.filters}
                                />
                            );
                        case 'search':
                            return (
                                <TableFilterSearch
                                    key={`${filter.fieldName} ${index}`}
                                    onChange={onChange}
                                    filter={filter}
                                    intl={intl}
                                    activeFilters={activeFilters.search}
                                    className={classes.filters}
                                />
                            );
                        case 'date':
                            return (
                                <TableFilterDate
                                    key={`${filter.fieldName} ${index}`}
                                    onChange={onChange}
                                    filter={filter}
                                    intl={intl}
                                    activeFilters={activeFilters.date}
                                    className={classes.filters}
                                />
                            );
                        default:
                            return null;
                    }
                })}
            </Grid>
        );
    }
}

export default withStyles(styles)(createForm()(injectIntl(TableFilters)));
